import React, { Component } from 'react';
import { Col } from 'react-bootstrap';
import DatePicker from 'react-bootstrap-date-picker';

import Combobox from '../Combobox';

/**
* Class DateFilter
* Generic component to generate date filters
**/
class DateFilter extends Component {
  /**
  * props
  * title : title of the field
  * name : reference name prefix
  * parentFilter : parent filter reference
  **/

  /**
  * constructor
  * Constructor
  **/
  constructor(props) {
    super(props);

    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleCompareChange = this.handleCompareChange.bind(this);

    this.currentComparator = undefined;
    this.currentDate = undefined;
  }

  /**
  * render
  * Rendering component function : display the date filter
  **/
  render() {
    // Form rendering
    const cbxData = {
        collection: [{
          id: ">",
          name: ">"
          // name: "Strictement supérieur"
        },{
          id: ">=",
          name: ">="
          // name: "Supérieur"
        },{
          id: "=",
          name: "="
          // name: "Egal"
        },{
          id: "<=",
          name: "<="
          // name: "Inférieur"
        },{
          id: "<",
          name: "<"
          // name: "Strictement inférieur"
        }]
    };

    const cbxProps = {
      dataSource: cbxData,
      onChange: this.handleCompareChange,
      forceSelection: true
    };

    if(this.props.default) {
      cbxProps.default = this.props.default;
      this.currentComparator = this.props.default;
    }

    return(
      <div>
        <Col componentClass="filterDateCombo" sm={1}>
          <Combobox {...cbxProps} />
        </Col>
        <Col sm={2}><DatePicker id={this.props.name} dateFormat="DD/MM/YYYY" onChange={this.handleDateChange} placeholder={this.props.title} /></Col>
      </div>
    );

    // return(
    //   <FormGroup>
    //     <Col componentClass="filterDateLabel" sm={1}><ControlLabel>{this.props.title}</ControlLabel></Col>
    //     <Col componentClass="filterDateCombo" sm={1}>
    //       <Combobox {...cbxProps} />
    //     </Col>
    //     <Col sm={2}><DatePicker id={this.props.name} dateFormat="DD/MM/YYYY" onChange={this.handleDateChange} placeholder={this.props.title} /></Col>
    //   </FormGroup>
    // );
  }

  /**
  * handleChange
  * Call the handleDateChange of the parent
  **/
  handleDateChange(dateString, dateValue) {
    this.currentDate = dateValue;
    this.props.parentFilter.handleDateChange(this, this.currentDate, this.currentComparator);
  }

  /**
  * handleCompareChange
  * Call the handleCompareChange of the parent
  **/
  handleCompareChange(compareObj) {
    this.currentComparator = compareObj.id;
    this.props.parentFilter.handleDateChange(this, this.currentDate, this.currentComparator);
  }

  /**
  * reset
  * Reset the value
  **/
  reset() {
    this.setState({});
  }

}

export default DateFilter;



// WEBPACK FOOTER //
// ./src/views/Helper/GridFilter/DateFilter.js